import { render, staticRenderFns } from "./ModalAddSearchWidget.vue?vue&type=template&id=7d40a21a"
import script from "./ModalAddSearchWidget.vue?vue&type=script&lang=js"
export * from "./ModalAddSearchWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports